import { cs } from '../../../lib/currency';
import { CreditCard, Loader2 } from 'lucide-react';
import { Button } from '../../ui/button';

/**
 * Floating cart bar — appears whenever the customer has staged one or more
 * slot selections via "+ Add to cart". Shows running total + a single button
 * that hands ALL items to the bulk checkout endpoint in one Stripe Checkout
 * Session.
 *
 * Pure presentation: receives the cart state + handlers from the parent
 * `LaneBooking` page so the parent retains the source of truth.
 */
const BookingCart = ({
  cartBookings,
  cartTotal,
  bulkCheckoutLoading,
  onClear,
  onCheckout,
}) => {
  if (!cartBookings || cartBookings.length === 0) return null;

  return (
    <div
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 w-[95%] max-w-2xl rounded-xl shadow-2xl bg-slate-900 text-white px-4 py-3 flex items-center gap-3"
      data-testid="cart-bar"
    >
      <CreditCard className="h-5 w-5 text-emerald-400 flex-shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="font-semibold">
          {cartBookings.length} booking{cartBookings.length === 1 ? '' : 's'} in cart
          <span className="ml-2 text-emerald-400">{cs()}{cartTotal.toFixed(2)}</span>
        </div>
        <div className="text-xs text-slate-300 truncate">
          {cartBookings.map((c) => `${c.lane_name} · ${c.start_time}`).join('  ·  ')}
        </div>
      </div>
      <Button
        size="sm"
        variant="ghost"
        onClick={onClear}
        className="text-slate-300 hover:text-white hover:bg-slate-800"
        data-testid="cart-clear"
      >
        Clear
      </Button>
      <Button
        size="sm"
        onClick={onCheckout}
        disabled={bulkCheckoutLoading}
        className="bg-emerald-500 hover:bg-emerald-600"
        data-testid="cart-checkout-btn"
      >
        {bulkCheckoutLoading ? (
          <>
            <Loader2 className="h-4 w-4 mr-1 animate-spin" />
            Loading...
          </>
        ) : (
          <>Pay {cs()}{cartTotal.toFixed(2)}</>
        )}
      </Button>
    </div>
  );
};

export default BookingCart;
